document.addEventListener('DOMContentLoaded', function() {
    var journalWrapper = document.querySelector('.journal-wrapper');
    if (journalWrapper) { // Checks if .journal-wrapper exists
      var li = document.querySelector('.journal-wrapper .book-wrapper__buy-section li:last-of-type');
      if (li && li.textContent.includes('First Issue:')) {
        li.textContent = li.textContent.replace('First Issue:', 'Current Issue:');
      }
    }
  });

(function($) {
    $(function() {

        var $selectElements = $('.js-select');
        
        $selectElements.each(function(index) {

            $(this).on('change', function(e) {

                var $select = $(e.target);

                if ($select.data('function') === 'change-url') {

                    var $url = this.value;

                    if ($url === 'undefined' || $url === null || $url === '') {
                        return;
                    }

                    // change location to what ever url was in the data-url attribute
                    $(location).attr('href', $url);

                }

            });

        });
    });
})(jQuery);